import { notifyApiCallError } from 'app/http/notifyApiCallError';
import { useEffect } from 'react';

export const useNotifyQueryError = (error: unknown) => {
  useEffect(() => {
    if (error) {
      notifyApiCallError(error);
    }
  }, [error]);
};
